//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            questions: [
                {
                    answer: '',
                    correctAnswer: 'A'
                },
                {
                    answer: '',
                    correctAnswer: 'A'
                },
                {
                    answer: '',
                    correctAnswer: 'B'
                },
                {
                    answer: '',
                    correctAnswer: 'B'
                },
                {
                    answer: '',
                    correctAnswer: 'A'
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.questions.filter(question => question.answer === question.correctAnswer).length;
            let numTotalCorrect = this.questions.length;

            return this.$game.getMultipleChoiceResult(numCorrect, numTotalCorrect, 0);
        }
    }
};
